import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue, setValue } from "@utils/lodash";
import NoAccessPage from "@components/common/NoAccess";
import {
  convertDate,
  convertDateAsString,
  currentDate,
} from "@_common/date-helpers";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import {
  getChildEntityGroups,
  getEntityGroups,
  getUserEntityGroups,
  getUserEntityGroupsItems,
} from "@services/entity-mapping.service";
import SearchHeader from "@components/common/SearchHeader";
import {
  exportSelfCompliance,
  getDashboardSelfComplianceUserEntity,
  getDashboardSelfComplianceUserEntityByLevel,
  getDashboardSelfComplianceUserEntityDataByLevel,
  refreshComplaince,
  getDashboardSelfActivityByLevel,
} from "@services/dashboard.service";
import { NewDate } from "@_common/date-helpers";
import { Doughnut, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
// import "chartjs-plugin-datalabels";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Loader from "@components/common/Loader";
import { formatString, formatText } from "@_common/format-text";
import DashboardUserFilterForm from "@components/common/DashboardFilterForm/user-filter-form";
import SelfComplianceTable from "../SelfCompliance/Table";
import Notfound from "@components/Not-Found";
import _ from "lodash";
import GraphLoader from "@components/common/GraphLoader";
import GraphNotfound from "@components/common/Graph-Not-Found";
import { tableStatusColors } from "@_common/colors";
import DownloadOfflineSvgComponent from "../../../assets/svg-components/download-offline";
import RefreshSvgComponent from "../../../assets/svg-components/refresh";
import ReactTooltip from "react-tooltip";
import DownloadNoCircleSvgComponent from "../../../assets/svg-components/download-nocircle";

import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import DashboardSelfComplianceNotfound from "@components/Page-Not-Found/dashboard-self-compliance";
import DashboardSvgComponent from "../../../assets/svg-components/left-menu/dashboard";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import {
  concatString,
  convertCamelToSnakeCase,
  countKeysWithValues,
  decodeBase64,
  json2array,
} from "@_common/text-helpers";
import { ResponsivePie } from "@stu-dev/nivo-pie";
import html2canvas from "html2canvas";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import moment from "moment";
import AssignedSvgComponent from "../../../assets/svg-components/assigned";
import PosingSvgComponent from "../../../assets/svg-components/posing";
import CompliedSvgComponent from "../../../assets/svg-components/complied";
import NonCompliedSvgComponent from "../../../assets/svg-components/non-complied";
import DelayedSvgComponent from "../../../assets/svg-components/delayed";
import DelayReportedSvgComponent from "../../../assets/svg-components/delay-reported";
import ReopenedSvgComponent from "../../../assets/svg-components/reopened";
import OverdueSvgComponent from "../../../assets/svg-components/overdue";
import UpcomingSvgComponent from "../../../assets/svg-components/upcoming";
import DueTodaySvgComponent from "../../../assets/svg-components/due-today";
import TotalSvgComponent from "../../../assets/svg-components/total";
import SubmissionApprovalSvgComponent from "../../../assets/svg-components/submission-approval";
import PendingApprovalSvgComponent from "../../../assets/svg-components/pending-approval";
import InfoSvgComponent from "../../../assets/svg-components/info";
import DOverdueSvgComponent from "../../../assets/svg-components/my-activity/overdue";
import DPendingCompletionSvgComponent from "../../../assets/svg-components/my-activity/pending-completion";
import DPendingApprovalSvgComponent from "../../../assets/svg-components/my-activity/pending-approval";
import FooterWrapper from "@components/common/FooterWrapper";
import PaginationPage from "@components/pagination/pagination";
import { legalUpdate } from "@services/reports.service";
import DashboardBlogsViewPopup from "./view";
import ExpandableComplianceTableMyActivity from "./expandableTable";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title
  // ChartDataLabels
);

type DonutDataItem = {
  id: string;
  label: string;
  value: number; // Assuming value is a number
  color: string;
};

type NumberDonutDataItem = {
  id: string;
  label: string;
  value: number; // Assuming value is a number
  color: string;
};

export default function DashboardActivity(props: any) {
  const navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                                UseState Section                            */
  /* -------------------------------------------------------------------------- */
  const [isLoading, setIsLoading] = useState(true);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  const [data, setData] = useState({});
  const [activityLabels, setActivityLabels] = useState([]);
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const handleFilter = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  const [pageFilters, setpageFilters] = useState<any>([]);
  const [dashboardType, setDashboardType] = useState("EXECUTOR");
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      getDataLegalList();
      getSpecificGroupChart(1, page_no);
      getHeaderList(paramsObj, 0);
      getComplianceGraphData();
      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      setFirstDay(from_date);
      setLastDay(to_date);
    }
    if (props.permissionAPITriggered) {
      let filters = [
        { value: "EXECUTOR", label: "Executor", id: "EXECUTOR" },
        { value: "EVALUATOR", label: "Evaluator", id: "EVALUATOR" },
        { value: "FUNCTION_HEAD", label: "Function Head", id: "FUNCTION_HEAD" },
      ];

      let filtered = filters.filter((item: object) =>
        getValue(props, `permissions`, []).includes(
          getValue(item, `value`, "").toLowerCase()
        )
      );
      handleNavigateDashboard(getValue(filtered, `[${0}].value`, ""));
      setpageFilters(filtered);
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      if (!getValue(params, `level`, "")) {
        getData();
        getComplianceGraphData();
      }
      getDataLegalList();
      if (getValue(params, `level`, "")) {
        getSpecificGroupChart(getValue(params, `level`, "1"), page_no);
      }
      if (params.from_date && params.to_date) {
        // setDate(new Date(params.date));
        var from_date = new Date(params.from_date);
        var to_date = new Date(params.to_date);
        setFirstDay(from_date);
        setLastDay(to_date);
      } else {
        let dates = params.date ? new Date(params.date) : new Date();
        var from_date = new Date(dates.getFullYear(), dates.getMonth(), 1);
        var to_date = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
        setFirstDay(from_date);
        setLastDay(to_date);
      }
      if (params.dashboard_type) {
        setDashboardType(params.dashboard_type);
      }
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
        setLimitTable(parseInt(params.limit));
      }

      let paramObj: any = {};
      //finding only levels params if it presented in URL
      for (let i = 1; i < 11; i++) {
        if (getValue(params, `level${i}`, "")) {
          paramObj[`level${i}`] = getValue(params, `level${i}`, "");
        }
      }
      setParamsObj(paramObj);
      getHeaderList(paramObj, 0);
      if (Object.keys(paramObj).length > 0) {
        setFilterVisibility(true);
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                                  API Section                               */
  /* -------------------------------------------------------------------------- */
  // Define colors for each key
  const colorsNew: { [key: string]: string } = {
    assigned: "#D0D3D4",
    posing: "#fd9933",
    complied: "#05a357",
    non_complied: "#EC7063",
    delayed: "#D4AC0D",
    delay_reported: "#85C1E9",
    re_opened: "#FADBD8",
    event_not_occured: "#BF94BC",
    awaiting_approval: "#4B6C81",
    reported_non_complied: "#c25071",
  };

  const colorsChartNew = [
    "#D0D3D4",
    "#fd9933",
    "#05a357",
    "#EC7063",
    "#D4AC0D",
    "#85C1E9",
    "#FADBD8",
    "#BF94BC",
    "#4B6C81",
    "#c25071",
  ];

  const [donutData, setDonutData] = useState<DonutDataItem[]>([]);
  const [numberDonutData, setNumberDonutData] = useState<NumberDonutDataItem[]>(
    []
  );

  const [legendDonutData, setLegendDonutData] = useState<DonutDataItem[]>([]);
  const [legendNumberDonutData, setLegendNumberDonutData] = useState<
    DonutDataItem[]
  >([]);

  function snakeToCamelWithSpaces(str: string): string {
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  const normalizeKeys = (obj: Record<string, any>) => {
  const keyMap: Record<string, string> = {
    event_not_occured: "event_not_occurred",
  };

  return Object.entries(obj).reduce((acc, [key, value]) => {
    acc[keyMap[key] || key] = value;
    return acc;
  }, {} as Record<string, any>);
};

  const getData = async () => {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());

      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = params.from_date
        ? params.from_date
        : new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = params.to_date
        ? params.to_date
        : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

      // let payload: any = {
      //   from_date: convertDate(from_date),
      //   to_date: convertDate(to_date),
      //   dashboard_type: params.dashboard_type
      //     ? params.dashboard_type
      //     : dashboardType,
      // };
      let payload: any = {
        ...(params.is_executor_date
          ? {
              owner_due_date_from: convertDate(from_date),
              owner_due_date_to: convertDate(to_date),
            }
          : params.is_evaluator_date
          ? {
              approver_due_date_from: convertDate(from_date),
              approver_due_date_to: convertDate(to_date),
            }
          : params.is_function_head_date
          ? {
              function_head_due_date_from: convertDate(from_date),
              function_head_due_date_to: convertDate(to_date),
            }
          : {
              from_date: convertDate(from_date),
              to_date: convertDate(to_date),
            }),
        dashboard_type: params.dashboard_type
          ? params.dashboard_type
          : dashboardType,
      };

      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let levelObj: any = {};
      //finding only levels params if it presented in URL
      for (let i = 1; i < 11; i++) {
        if (getValue(paramsObj, `level${i}`, "")) {
          levelObj[`level_${i}`] = getValue(paramsObj, `level${i}`, "").split(
            "_"
          )[0];
        }
      }
      setIsLoading(true);
      let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
      let resp = await getDashboardSelfComplianceUserEntityByLevel(
        queryRequest
      );
      console.log(resp,"r1")
      // if (resp) {
      //   // Self Compliance Percentage Graph
      //   const dataNew = getValue(resp, `data.fixed`, {});
      //   const total: number = Object.values(dataNew).reduce(
      //     (acc: number, val: any) => acc + (typeof val === "number" ? val : 0),
      //     0
      //   );
      //   const transformedData: DonutDataItem[] = Object.entries(dataNew).map(
      //     ([id, value], index) => {
      //       return {
      //         id: snakeToCamelWithSpaces(id),
      //         label: snakeToCamelWithSpaces(id),
      //         value:
      //           typeof value === "number"
      //             ? parseFloat(((value / total) * 100).toFixed(2))
      //             : 0,
      //         color: colorsNew[id],
      //       };
      //     }
      //   );

      //   // const formattedTransformedData: DonutDataItem[] = transformedData.map(
      //   //   (item) => ({
      //   //     ...item,
      //   //     value: parseFloat(item.value.toFixed(2)),
      //   //     displayValue: item.value.toFixed(2) + "%",
      //   //   })
      //   // );
      //   const formattedTransformedData: DonutDataItem[] = transformedData.map(
      //     (item) => ({
      //       ...item,
      //       value: parseFloat(item.value.toFixed(2)),
      //       displayValue: item.value.toFixed(2) + "%",
      //     })
      //   );

      //   // const chartData = formattedTransformedData.filter((item) => item.value !== 0);
      //   setLegendDonutData(formattedTransformedData);
      //   setDonutData(formattedTransformedData);

      //   // setDonutData(formattedTransformedData);

      //   // Self Compliance Number Graph
      //   const dataNewNumber = getValue(resp, `data.fixed`, {});
      //   const totalNumber: number = Object.values(dataNewNumber).reduce(
      //     (acc: number, val: any) => acc + (typeof val === "number" ? val : 0),
      //     0
      //   );
      //   const transformedDataNumber: NumberDonutDataItem[] = Object.entries(
      //     dataNewNumber
      //   ).map(([id, value], index) => ({
      //     id: snakeToCamelWithSpaces(id),
      //     label: snakeToCamelWithSpaces(id),
      //     value: typeof value === "number" ? value : 0,
      //     color: colorsNew[id],
      //   }));

      //   const formattedTransformedDataNumber: NumberDonutDataItem[] =
      //     transformedDataNumber.map((item) => ({
      //       ...item,
      //       value: parseFloat(item.value.toFixed(0)),
      //       displayValue: item.value.toFixed(0),
      //     }));
      //   // const chartNumberData = formattedTransformedData.filter((item) => item.value !== 0);
      //   setLegendNumberDonutData(formattedTransformedDataNumber);
      //   setNumberDonutData(formattedTransformedDataNumber);

      //   setData(getValue(resp, `data.percentage`, {}));
      //   let labels: any = Object.keys(getValue(resp, `data.percentage`, {}));
      //   setActivityLabels(labels);
      //   let formattedLabels: any =
      //     getValue(labels, `length`, 0) > 0
      //       ? labels.map((item: any) => formatText(item))
      //       : [];
      //     console.log(formatLabelValue,"formattedLabels")
      //   let data: any = labels.map((item: any) =>
      //     parseFloat(getValue(resp, `data.percentage`, {})[item])
      //   );
      //   console.log(data,"ddd")
      //   setValue(pieChartData, `labels`, formattedLabels);
      //   setValue(pieChartData, `datasets[${0}].data`, data);

      //   let data1: any = labels.map((item: any) =>
      //     parseFloat(getValue(resp, `data.fixed`, {})[item])
      //   );
      //   console.log(data1,"data1")
      //   setValue(pieChartData1, `labels`, formattedLabels);
      //   setValue(pieChartData1, `datasets[${0}].data`, data1);

      //   setValue(barChartData, `labels`, formattedLabels);
      //   setValue(barChartData, `datasets[${0}].data`, data);
      //   setBarChartData({
      //     ...barChartData,
      //   });
      //   setPieChartData({
      //     ...pieChartData,
      //   });
      //   setPieChartData1({
      //     ...pieChartData1,
      //   });
      //   // setTimeout(() => {
      //   setIsLoading(false);
      //   // }, 1000);
      // } else {
      //   setIsLoading(false);
      // }

      if (resp) {
  const fixedData = normalizeKeys(getValue(resp, `data.fixed`, {}));
  const percentageData = normalizeKeys(
    getValue(resp, `data.percentage`, {})
  );

  // Self Compliance Percentage Graph
  const total: number = Object.values(fixedData).reduce(
    (acc: number, val: any) => acc + (typeof val === "number" ? val : 0),
    0
  );

  const transformedData: DonutDataItem[] = Object.entries(fixedData).map(
    ([id, value]) => {
      return {
        id: snakeToCamelWithSpaces(id),
        label: snakeToCamelWithSpaces(id),
        value:
          typeof value === "number"
            ? parseFloat(((value / total) * 100).toFixed(2))
            : 0,
        color: colorsNew[id],
      };
    }
  );

  const formattedTransformedData: DonutDataItem[] = transformedData.map(
    (item) => ({
      ...item,
      value: parseFloat(item.value.toFixed(2)),
      displayValue: item.value.toFixed(2) + "%",
    })
  );

  setLegendDonutData(formattedTransformedData);
  setDonutData(formattedTransformedData);

  // Self Compliance Number Graph
  const transformedDataNumber: NumberDonutDataItem[] = Object.entries(
    fixedData
  ).map(([id, value]) => ({
    id: snakeToCamelWithSpaces(id),
    label: snakeToCamelWithSpaces(id),
    value: typeof value === "number" ? value : 0,
    color: colorsNew[id],
  }));

  const formattedTransformedDataNumber: NumberDonutDataItem[] =
    transformedDataNumber.map((item) => ({
      ...item,
      value: parseFloat(item.value.toFixed(0)),
      displayValue: item.value.toFixed(0),
    }));

  setLegendNumberDonutData(formattedTransformedDataNumber);
  setNumberDonutData(formattedTransformedDataNumber);

  setData(percentageData);

  let labels: any = Object.keys(percentageData);

  setActivityLabels(labels);

  let formattedLabels: any =
    labels.length > 0
      ? labels.map((item: any) => formatText(item))
      : [];

  let data: any = labels.map((item: any) =>
    parseFloat(percentageData[item])
  );

  setValue(pieChartData, `labels`, formattedLabels);
  setValue(pieChartData, `datasets[0].data`, data);

  let data1: any = labels.map((item: any) =>
    parseFloat(fixedData[item] ?? 0)
  );

  setValue(pieChartData1, `labels`, formattedLabels);
  setValue(pieChartData1, `datasets[0].data`, data1);

  setValue(barChartData, `labels`, formattedLabels);
  setValue(barChartData, `datasets[0].data`, data);

  setBarChartData({
    ...barChartData,
  });

  setPieChartData({
    ...pieChartData,
  });

  setPieChartData1({
    ...pieChartData1,
  });

  setIsLoading(false);
} else {
  setIsLoading(false);
}
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getDataParamsObj = async (paramsObj: object) => {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());

      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = params.from_date
        ? params.from_date
        : new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = params.to_date
        ? params.to_date
        : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      let payload: any = {
        from_date: convertDate(from_date),
        to_date: convertDate(to_date),
      };
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let levelObj: any = {};
      //finding only levels params if it presented in URL
      for (let i = 1; i < 11; i++) {
        if (getValue(paramsObj, `level${i}`, "")) {
          levelObj[`level_${i}`] = getValue(paramsObj, `level${i}`, "").split(
            "_"
          )[0];
        }
      }
      setIsLoading(true);
      let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
      let resp = await getDashboardSelfComplianceUserEntity(queryRequest);
      // let resp = await getDashboardSelfCompliance(queryRequest);
      if (resp) {
        setData(getValue(resp, `data`, {}));
        let labels: any = Object.keys(getValue(resp, `data`, {}));
        setActivityLabels(labels);
        let formattedLabels: any =
          getValue(labels, `length`, 0) > 0
            ? labels.map((item: any) => formatString(item))
            : [];
        let data: any = labels.map(
          (item: any) => getValue(resp, `data`, {})[item]
        );
        setValue(pieChartData, `labels`, formattedLabels);
        setValue(pieChartData, `datasets[${0}].data`, data);

        // setValue(barChartData, `labels`, formattedLabels);
        // setValue(barChartData, `datasets[${0}].data`, data);
        // setBarChartData({
        //   ...barChartData,
        // });
        setPieChartData({
          ...pieChartData,
        });
        // setTimeout(() => {
        setIsLoading(false);
        // }, 1000);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  /* ---------------------------  Entity Mapping Filters  ----------------------------- */

  const [headerList, setHeaderList] = useState([]);
  const [headerGroupList, setHeaderGroupList] = useState<any>([]);

  const [headerLoading, setHeaderLoading] = useState(true);
  const [levelObj, setLevelObj] = useState<any>({});
  const [paramsObj, setParamsObj] = useState<any>({});

  const getHeaderList = async (paramsObj: any, index: number) => {
    let userSpec = getValue(localStorage, `user`, {});
    let user: any = JSON.parse(userSpec);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
      // user_id:getValue(user,`id`,'')
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await getEntityGroups(queryRequest);
      // let resp = await getUserEntityGroups(queryRequest)
      if (resp) {
        setHeaderList(getValue(resp, `data.entityGroups`, []));
        let headers = [{ group_name: "Overall" }];
        let headerGroups = getValue(resp, `data.entityGroups`, []);
        setHeaderGroupList(headers.concat(headerGroups));
        var result: any = {};
        for (
          let i = 0;
          i < getValue(resp, `data.entityGroups.length`, 0);
          i++
        ) {
          result[
            `${getValue(resp, `data.entityGroups[${i}].group_level`, "")}`
          ] = { [getValue(resp, `data.entityGroups[${i}].id`, "")]: {} };
        }
        if (Object.keys(levelObj).length === 0) {
          for (let x in result) {
            let keys = Object.keys(result[x])[0];
            levelObj[keys] = {};
          }
        }
        // delete params[`checkpoint_id[]`];
        let list =
          Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];

        if (getValue(list, `length`, 0) > 0) {
          getEntityList(
            1,
            getValue(resp, `data.entityGroups[${0}].id`, ""),
            null,
            ""
          );

          list.map((item: any, _index: number) => {
            let findNextLevelInfo = getValue(
              resp,
              `data.entityGroups`,
              []
            ).filter(
              (ite: any, i: number) =>
                ite.group_level - 1 === parseInt(item.split("_")[2])
            );
            // if (_index === index)
            return getEntityList(
              parseInt(item.split("_")[2]) + 1,
              getValue(findNextLevelInfo, `[${0}].id`, ""),
              item.split("_")[0],
              ""
            );
          });
        } else {
          getEntityList(
            1,
            getValue(resp, `data.entityGroups[${0}].id`, ""),
            null,
            ""
          );
        }
        setHeaderLoading(false);
      } else {
        setHeaderLoading(false);
      }
    } catch (error) {
      setHeaderLoading(false);
    }
  };

  const getEntityGroupsUponSelection = async (
    paramsObj: object,
    index: number,
    group_level: any,
    entity_id: any
  ) => {
    let list =
      Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
    if (getValue(list, `length`, 0) > 0) {
      list.map((item: any, _index: number) => {
        let findNextLevelInfo = headerList.filter(
          (ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1
        );
        if (_index === index)
          return getEntityList(
            group_level,
            getValue(findNextLevelInfo, `[${0}].id`, ""),
            entity_id,
            ""
          );
      });
    }
  };
  const [childEntityList, setChildEntityList] = useState<any>({});
  const [childEntityLoading, setChildEntityLoading] = useState(false);
  const getEntityList = async (
    group_level: any,
    group_id: string,
    entity_id: any,
    search_text: string
  ) => {
    let payload = {
      limit: 10,
      search_text: search_text,
      level: group_level,
      entity_parent: entity_id,
    };

    let queryRequest = QueryRequestHelper(payload);
    setChildEntityLoading(true);
    try {
      // let resp = await getChildEntityGroups(queryRequest);
      let resp = await getUserEntityGroupsItems(queryRequest);
      if (resp) {
        levelObj[group_id] = getValue(resp, `data.entityMapping`, []).map(
          (item: any) => ({
            ...item,
            value: getValue(item, `entity_name`, ""),
            label: getValue(item, `entity_name`, ""),
          })
        );
        setLevelObj({ ...levelObj });
        setChildEntityLoading(false);
      } else {
        setChildEntityLoading(false);
      }
    } catch (error) {
      setChildEntityLoading(false);
    }
  };

  const handleClickEntity = (
    entity_id: any,
    group_id: any,
    group_level: any,
    headerIndex: number
  ) => {
    //user selected level
    let userLevel = `${entity_id}_${group_id}_${group_level}`;
    let payload = { ...paramsObj };
    let selectedLevels =
      Object.values(payload).length > 0 ? Object.values(payload) : [];
    if (!selectedLevels.includes(userLevel)) {
      // appending child entity list that are presented in URL Params
      var result = Object.entries(childEntityList);
      var myNewArray: any =
        getValue(result, `length`, 0) > 0
          ? result.filter(function (item, index) {
              return index + 1 <= group_level;
            })
          : [];
      let obj: any = {};
      if (getValue(myNewArray, `length`, 0) > 0) {
        myNewArray.map((item: any) => {
          obj[item[0]] = item[1];
        });
      }
      setChildEntityList(obj);

      //deleting params if grater then current level selected by the user
      for (let i = group_level + 1; i < 10; i++) {
        delete paramsObj[`level${i}`];
      }

      // replacing url param if it have same group level / else we can add new one
      let checkIfAlreadyExist =
        Object.keys(payload).length > 0
          ? Object.keys(payload).includes(`level${group_level}`)
          : false;
      if (checkIfAlreadyExist) {
        delete paramsObj[`level${group_level}`];
        let obj = {
          ...paramsObj,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getEntityGroupsUponSelection(
          obj,
          headerIndex,
          parseInt(group_level) + 1,
          entity_id
        );
      } else {
        let obj = {
          ...paramsObj,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getEntityGroupsUponSelection(
          obj,
          headerIndex,
          parseInt(group_level) + 1,
          entity_id
        );
      }
    } else {
      // toast.error("Already selected");
    }
  };
  const handleChange = (
    val: string,
    group_id: string,
    group_level: any,
    index: number
  ) => {
    let entityID = getValue(paramsObj, `level${parseInt(group_level) - 1}`, "")
      ? getValue(paramsObj, `level${parseInt(group_level) - 1}`, "").split(
          "_"
        )[0]
      : null;

    if (!val) {
      getEntityList(group_level, group_id, entityID, "");
      let length = Object.keys(paramsObj).length;
      for (let i = group_level; i <= length; i++) {
        let id =
          paramsObj[`level${i + 1}`] &&
          paramsObj[`level${i + 1}`].split("_")[1];
        if (id) {
          levelObj[id] = {};
        }
        delete paramsObj[`level${i}`];
      }
      let obj = {
        ...paramsObj,
      };
      setParamsObj(obj);
      getHeaderList(obj, index);
    } else {
      getEntityList(group_level, group_id, entityID, val);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                              Date Routes                                   */
  /* -------------------------------------------------------------------------- */
  const [from_date, setFirstDay] = React.useState<any>(null);
  const [to_date, setLastDay] = React.useState<any>(null);

  const handleDate = (date: any) => {
    setFirstDay(date[0]);
    setLastDay(date[1]);
  };
  const handleSubmitDate = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let first: any = from_date ? NewDate(from_date) : null;
    let last: any = to_date ? NewDate(to_date) : null;
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let payload: any = {
        ...params,
        from_date: convertDate(first),
        to_date: convertDate(last),
      };
      if (payload.from_date && payload.to_date) {
        let queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        toast.error("Start Date and End Date Required");
      }
    } else {
      toast.error("Please select date");
    }
  };
  const handleSubmitSmartFilter = () => {
    let levelObj: any = {};
    //finding only levels params if it presented in URL
    for (let i = 1; i < 11; i++) {
      if (getValue(paramsObj, `level${i}`, "")) {
        levelObj[`level${i}`] = getValue(paramsObj, `level${i}`, "");
      }
    }
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      // page_no: getValue(params, `page_no`, ""),
      // search_text: getValue(params, `search_text`, ""),
      // limit: getValue(params, `limit`, ""),
    };
    let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
    navigate(`${window.location.pathname}?${queryRequest}`);
    handleFilter();
  };

  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    setParamsObj({});
    setFilterVisibility(false);
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    getDataParamsObj({});
  };
  /* -------------------------------------------------------------------------- */
  /*                              Chart Section                                 */
  /* -------------------------------------------------------------------------- */
  /* ---------------------------------- Pie Chart ----------------------------- */

  const [pieChartData, setPieChartData] = useState<any>({
    labels: ["Default"],
    datasets: [
      {
        label: "Default",
        data: [],
        backgroundColor: [
          // "rgb(242,165,152)",
          // "rgb(255,232,157)",
          // "rgb(236,107,109)",
          // "rgb(122,231,125)",
          // "rgb(195,233,151)",
          // "#ffcd56",
          // "#4bc0c0"
          "#D0D3D4",
          "#fd9933",
          "#05a357",
          "#EC7063",
          "#D4AC0D",
          "#85C1E9",
          "#FADBD8",
          "#BF94BC",
          "#4B6C81",
          "#c25071",
        ],
        borderWidth: 1,
      },
    ],
  });

  const [pieChartData1, setPieChartData1] = useState<any>({
    labels: ["Default"],
    datasets: [
      {
        label: "Default",
        data: [],
        backgroundColor: [
          // "rgb(242,165,152)",
          // "rgb(255,232,157)",
          // "rgb(236,107,109)",
          // "rgb(122,231,125)",
          // "rgb(195,233,151)",
          // "#ffcd56",
          // "#4bc0c0"
          "#D0D3D4",
          "#fd9933",
          "#05a357",
          "#EC7063",
          "#D4AC0D",
          "#85C1E9",
          "#FADBD8",
          "#BF94BC",
          "#4B6C81",
          "#c25071",
        ],
        borderWidth: 1,
      },
    ],
  });

  const handleClickPieChart = (index: number, request_value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let first: any = from_date ? NewDate(from_date) : null;
    let last: any = to_date ? NewDate(to_date) : null;
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let selectedEnum =
        getValue(activityLabels, `length`, 0) > 0
          ? activityLabels.filter((_item: string, ind: number) => index === ind)
          : [];
      let payload: any = {
        ...params,
        // from_date: convertDate(first),
        // to_date: convertDate(last),
        ...(params.is_executor_date
          ? {
              owner_due_date_from: convertDate(from_date),
              owner_due_date_to: convertDate(to_date),
            }
          : params.is_evaluator_date
          ? {
              approver_due_date_from: convertDate(from_date),
              approver_due_date_to: convertDate(to_date),
            }
          : params.is_function_head_date
          ? {
              function_head_due_date_from: convertDate(from_date),
              function_head_due_date_to: convertDate(to_date),
            }
          : {
              from_date: convertDate(first),
              to_date: convertDate(last),
            }),
        request_from: "MASTER",
        is_user_entity: true,
        dashboard_type: dashboardType,
        request_value: request_value,
        status: "active",
      };
      let queryRequest = QueryRequestHelper(payload);
      if (getValue(selectedEnum, `length`, 0) > 0) {
        // navigate(`/repository/mapped-checkpoint/master?${queryRequest}`);
        switch (dashboardType) {
          case "EXECUTOR":
            return navigate(
              `/activities/self-compliance/my-task?${queryRequest}`
            );
          // case "EVALUATOR":
          //   return navigate(
          //     `/repository/mapped-checkpoint/evaluator?${queryRequest}`
          //   );

          case "EVALUATOR":
            return navigate(
              request_value === "AWAITING_APPROVAL"
                ? `/activities/self-compliance/pending-approval?${queryRequest}`
                : `/repository/mapped-checkpoint/evaluator?${queryRequest}`
            );
          case "FUNCTION_HEAD":
            return navigate(
              `/repository/mapped-checkpoint/function-head?${queryRequest}`
            );
          default:
            return navigate(
              `/activities/self-compliance/my-task?${queryRequest}`
            );
        }
      }
    } else {
      toast.error("From and To Date Required");
    }
  };

  /* ---------------------------------- Bar Chart ----------------------------- */
  const [barChartData, setBarChartData] = useState({
    labels: ["Default"],
    datasets: [
      {
        label: "Compliance",
        data: [98, 120, 138, 138],
        backgroundColor: [
          "#F4F6F6",
          "#fd9933",
          "#05a357",
          "#d7252e",
          "#05a357",
          "rgb(195,233,151)",
          "#F1948A",
        ],
      },
    ],
  });

  const handleClickNewBarChart = (index: number) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let first: any = from_date ? NewDate(from_date) : null;
    let last: any = to_date ? NewDate(to_date) : null;
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let payload: any = {
        ...params,
        // from_date: convertDate(first),
        // to_date: convertDate(last),
        ...(params.is_executor_date
          ? {
              owner_due_date_from: convertDate(from_date),
              owner_due_date_to: convertDate(to_date),
            }
          : params.is_evaluator_date
          ? {
              approver_due_date_from: convertDate(from_date),
              approver_due_date_to: convertDate(to_date),
            }
          : params.is_function_head_date
          ? {
              function_head_due_date_from: convertDate(from_date),
              function_head_due_date_to: convertDate(to_date),
            }
          : {
              from_date: convertDate(first),
              to_date: convertDate(last),
            }),
        request_from: "NEW_DASHBOARD",
        request_type: "NON_COMPLIED_TASK_RISK",
        dashboard_type: dashboardType,
        request_value: getValue(activityBarChartData, `labels[${index}]`, ""),
        status: "active",
      };
      let queryRequest = QueryRequestHelper(payload);
      switch (dashboardType) {
        case "EXECUTOR":
          return navigate(
            `/activities/self-compliance/my-task?${queryRequest}`
          );
        case "EVALUATOR":
          return navigate(
            `/repository/mapped-checkpoint/evaluator?${queryRequest}`
          );
        case "FUNCTION_HEAD":
          return navigate(
            `/repository/mapped-checkpoint/function-head?${queryRequest}`
          );
        default:
          return navigate(
            `/activities/self-compliance/my-task?${queryRequest}`
          );
      }
    }
  };

  const handleClickNewBoxChart = (obj: any) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let first: any = from_date ? NewDate(from_date) : null;
    let last: any = to_date ? NewDate(to_date) : null;
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let payload: any = {
        ...params,
        // from_date: convertDate(first),
        // to_date: convertDate(last),
        ...(params.is_executor_date
          ? {
              owner_due_date_from: convertDate(from_date),
              owner_due_date_to: convertDate(to_date),
            }
          : params.is_evaluator_date
          ? {
              approver_due_date_from: convertDate(from_date),
              approver_due_date_to: convertDate(to_date),
            }
          : params.is_function_head_date
          ? {
              function_head_due_date_from: convertDate(from_date),
              function_head_due_date_to: convertDate(to_date),
            }
          : {
              from_date: convertDate(first),
              to_date: convertDate(last),
            }),
        request_from: "NEW_DASHBOARD",
        request_type: "COMPLIANCE_REPORTS",
        dashboard_type: dashboardType,
        request_value: getValue(obj, `activity`, ""),
        status: "active",
      };
      let queryRequest = QueryRequestHelper(payload);
      switch (dashboardType) {
        case "EXECUTOR":
          return navigate(
            `/activities/self-compliance/my-task?${queryRequest}`
          );
        case "EVALUATOR":
          return navigate(
            `/activities/self-compliance/pending-approval?${queryRequest}`
          );
        case "FUNCTION_HEAD":
          return navigate(
            `/repository/mapped-checkpoint/function-head?${queryRequest}`
          );
        default:
          return navigate(
            `/activities/self-compliance/my-task?${queryRequest}`
          );
      }
    }
  };

  const handleClickActivities = (
    obj: any,
    request_value: string,
    user_id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let first: any = from_date ? NewDate(from_date) : null;
    let last: any = to_date ? NewDate(to_date) : null;
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let payload: any = {
        ...params,
        // from_date: convertDate(first),
        // to_date: convertDate(last),
        ...(params.is_executor_date
          ? {
              owner_due_date_from: convertDate(from_date),
              owner_due_date_to: convertDate(to_date),
            }
          : params.is_evaluator_date
          ? {
              approver_due_date_from: convertDate(from_date),
              approver_due_date_to: convertDate(to_date),
            }
          : params.is_function_head_date
          ? {
              function_head_due_date_from: convertDate(from_date),
              function_head_due_date_to: convertDate(to_date),
            }
          : {
              from_date: convertDate(first),
              to_date: convertDate(last),
            }),
        request_from: "NEW_DASHBOARD",
        request_type: request_value,
        dashboard_type: dashboardType,
        request_value: getValue(obj, `custom_group`, ""),
        request_user: user_id,
        status: "active",
      };
      let queryRequest = QueryRequestHelper(payload);
      switch (dashboardType) {
        case "EXECUTOR":
          return navigate(
            `/activities/self-compliance/my-task?${queryRequest}`
          );
        case "EVALUATOR":
          return navigate(
            `/repository/mapped-checkpoint/evaluator?${queryRequest}`
          );
        case "FUNCTION_HEAD":
          return navigate(
            `/repository/mapped-checkpoint/function-head?${queryRequest}`
          );
        default:
          return navigate(
            `/activities/self-compliance/my-task?${queryRequest}`
          );
      }
    }
  };

  const handleClickGroupCharts = (
    value: any,
    request_value: string,
    user_id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let first: any = from_date ? NewDate(from_date) : null;
    let last: any = to_date ? NewDate(to_date) : null;
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      const groupName = getValue(selectedEntity, `[0].group_name`, ""); // Get group_name from selectedEntity
      let payload: any = {
        ...params,
        // from_date: convertDate(first),
        // to_date: convertDate(last),
        ...(params.is_executor_date
          ? {
              owner_due_date_from: convertDate(from_date),
              owner_due_date_to: convertDate(to_date),
            }
          : params.is_evaluator_date
          ? {
              approver_due_date_from: convertDate(from_date),
              approver_due_date_to: convertDate(to_date),
            }
          : params.is_function_head_date
          ? {
              function_head_due_date_from: convertDate(from_date),
              function_head_due_date_to: convertDate(to_date),
            }
          : {
              from_date: convertDate(first),
              to_date: convertDate(last),
            }),
        request_from: "MASTER",
        request_value: request_value,
        dashboard_type: dashboardType,
        value: value,
        status: "active",
        ...(groupName && { group_name: groupName }), // Add group_name to payload if it exists
      };
      let queryRequest = QueryRequestHelper(payload);
      switch (dashboardType) {
        case "EXECUTOR":
          return navigate(
            `/activities/self-compliance/my-task?${queryRequest}`
          );
        case "EVALUATOR":
          return navigate(
            `/repository/mapped-checkpoint/evaluator?${queryRequest}`
          );
        case "FUNCTION_HEAD":
          return navigate(
            `/repository/mapped-checkpoint/function-head?${queryRequest}`
          );
        default:
          return navigate(
            `/activities/self-compliance/my-task?${queryRequest}`
          );
      }
    }
  };

  /* ---------------------------------- Pie Group Chart ----------------------------- */
  const initialData = {
    labels: ["Default"],
    datasets: [
      {
        label: "Default",
        data: [],
        backgroundColor: [
          "rgb(242,165,152)",
          "rgb(255,232,157)",
          "rgb(236,107,109)",
          "rgb(122,231,125)",
          "rgb(195,233,151)",
          "#ffcd56",
          "#4bc0c0",
        ],
        stack: "",
        borderWidth: 1,
      },
    ],
  };
  const [groupChart, setGroupChart] = useState([]);
  const [groupChartLoading, setGroupChartLoading] = useState(false);
  const [groupPieChart, setGroupPieChart] = useState(initialData);
  const [groupActivityLabels, setGroupActivityLabels] = useState([]);
  const handleClickGroupPieChart = (level: any, groupName: any) => {
    setPage_no_table(1);
    setPage_no(1);

    const urlSearchParams = new URLSearchParams(window.location.search);
    const currentParams = Object.fromEntries(urlSearchParams.entries());

    // Remove existing level-specific parameters (level1, level2, etc.)
    // and potentially an old group_name if you decide to always overwrite it
    Object.keys(currentParams).forEach((key) => {
      if (key.startsWith("level") && key !== "level") {
        delete currentParams[key];
      }
      if (key === "group_name") {
        // Remove old group_name if present
        delete currentParams[key];
      }
    });

    let newParams: any = {
      ...currentParams, // Keep existing params like date range
    };

    if (level) {
      newParams.level = level;
      if (groupName) {
        // Add the new group_name if provided
        newParams.group_name = groupName;
      }
    } else {
      // If level is cleared (e.g., clicking "Overall" or a similar reset)
      delete newParams.level;
      delete newParams.group_name; // Also remove group_name
    }

    // Clean up undefined/null keys from the newParams
    Object.keys(newParams).forEach((key) => {
      if (
        newParams[key] === undefined ||
        newParams[key] === null ||
        newParams[key] === ""
      ) {
        delete newParams[key];
      }
    });

    const queryRequest = QueryRequestHelper(newParams);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };
  const getSpecificGroupChart = async (level: any, page_no: any) => {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = params.from_date
        ? params.from_date
        : new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = params.to_date
        ? params.to_date
        : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      let payload: any = {
        page_no: page_no,
        page_size: limit,
        // from_date: convertDate(from_date),
        // to_date: convertDate(to_date),
        ...(params.is_executor_date
          ? {
              owner_due_date_from: convertDate(from_date),
              owner_due_date_to: convertDate(to_date),
            }
          : params.is_evaluator_date
          ? {
              approver_due_date_from: convertDate(from_date),
              approver_due_date_to: convertDate(to_date),
            }
          : params.is_function_head_date
          ? {
              function_head_due_date_from: convertDate(from_date),
              function_head_due_date_to: convertDate(to_date),
            }
          : {
              from_date: convertDate(from_date),
              to_date: convertDate(to_date),
            }),
        level: level ? level : 1,
        dashboard_type: params.dashboard_type
          ? params.dashboard_type
          : dashboardType,
        ...(params.group_name && { group_name: params.group_name }),
      };
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });

      let queryRequest = QueryRequestHelper({ ...payload });
      setGroupChartLoading(true);
      // let resp = await getDashboardSelfComplianceUserEntity(queryRequest);
      let resp = await getDashboardSelfComplianceUserEntityDataByLevel(
        queryRequest,
        false
      );
      let resp1 = await getDashboardSelfComplianceUserEntityDataByLevel(
        queryRequest,
        true
      );
      if (resp1) {
        let arr: any = [];
        let length: any = Object.entries(
          getValue(resp1, `data.by_entity`, {})
        ).length;
        for (let i = 0; i < length; i++) {
          let filtered = Object.entries(getValue(resp1, `data.by_entity`, {}))[
            i
          ][0].split("::");
          arr.push({
            group_name: filtered[1],
            group_display_name: filtered[1] + ":" + filtered[3],
            group_id: filtered[0],
            data: Object.entries(getValue(resp1, `data.by_entity`, {}))[i][1],
          });
        }
        setGroupChart(getValue(arr, `length`, 0) > 0 ? arr : []);
        setGroupChartLoading(false);
        setTotalCountTable(getValue(resp, `data.pagination.total`, 0));
      } else {
        setGroupChartLoading(false);
      }
      if (resp) {
        const combinedStates: any = {};
        setList(getValue(resp, `data.by_entity`, {}));
        const inputJson = getValue(resp, `data.by_entity`, {});
        for (const key in inputJson) {
          const stateName = key.split("::")[1];
          if (combinedStates[stateName]) {
            // If the state already exists, add the properties
            for (const prop in inputJson[key]) {
              combinedStates[stateName][prop] += inputJson[key][prop];
            }
          } else {
            // If the state doesn't exist, create a new entry
            combinedStates[stateName] = { ...inputJson[key] };
          }
        }

        // Ensure that the sum of properties for each state is equal to 100
        for (const stateName in combinedStates) {
          const stateData = combinedStates[stateName];
          const total: any = Object.values(stateData).reduce(
            (acc: any, val) => acc + val,
            0
          );
          if (total !== 100) {
            // Adjust the values to make the total 100
            const factor = 100 / total;
            for (const prop in stateData) {
              stateData[prop] = parseFloat(
                (stateData[prop] * factor).toFixed(2)
              );
            }
          }
        }
        let labels: any = Object.keys(combinedStates);
        setGroupActivityLabels(labels);
        let formattedLabels: any =
          getValue(labels, `length`, 0) > 0
            ? labels.map((item: any) => formatString(item))
            : [];
        const newData = _.cloneDeep(initialData);
        for (let i = 0; i < labels.length; i++) {
          const normalizedLabel =
            getValue(labels, `[${i}]`, "") && labels[i].replace(/[\s.]+/g, "");
          const normalizedbject: any = {};
          let data: any = combinedStates;
          for (const key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
              // Remove spaces and periods from the key
              const modifiedKey = key && key.replace(/[\s.]+/g, "");
              // Assign the value to the modified key in the new object
              normalizedbject[modifiedKey] = data[key];
            }
          }
          const keys = Object.keys(
            getValue(normalizedbject, `[${normalizedLabel}]`, {})
          );
          let modifiedLabels =
            getValue(labels, `length`, 0) > 0 &&
            labels.map((item: any) => item && item.replace(/[\s.]+/g, ""));
          let obj =
            getValue(keys, `length`, 0) > 0 &&
            keys.map((item) => {
              let arr: any = [];
              getValue(labels, `length`, 0) > 0 &&
                modifiedLabels.map((lab: any, index: number) => {
                  return arr.push(
                    getValue(
                      normalizedbject,
                      `[${modifiedLabels[index]}][${item}]`,
                      0
                    )
                  );
                });
              return {
                label: formatText(item),
                stack: "",
                data: arr,
                backgroundColor: tableStatusColors(item.toUpperCase()),
              };
            });

          newData.datasets = obj;
        }
        newData.labels = formattedLabels || [];
        setValue(groupPieChart, `labels`, formattedLabels);

        setGroupPieChart(newData);
        // setList(
        //   getValue(resp, `data.by_entity`, {}).map((item: object) => ({
        //     ...item,
        //   }))
        // )
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
      } else {
        setIsLoading(false);
        setGroupChartLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setGroupChartLoading(false);
    }
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  let selectedEntity =
    getValue(headerList, `length`, 0) > 0
      ? headerList.filter(
          (item: any, index: number) =>
            getValue(item, `group_level`, 0) == getValue(params, `level`, 0) ||
            (index === 0 && !getValue(params, `level`, 0))
        )
      : [];

  const handleNavigate = (id: string, value: string) => {
    if (id !== "-") {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let first: any = from_date ? NewDate(from_date) : null;
      let last: any = to_date ? NewDate(to_date) : null;
      if (
        first &&
        last &&
        first !== "Invalid date" &&
        last !== "Invalid date"
      ) {
        let payload: any = {
          ...params,
          from_date: convertDate(first),
          to_date: convertDate(last),
          request_value: value,
          request_from: "MASTER",
          level_key: `${getValue(params, `level`, "")}`,
          level_value: id,
        };
        let queryRequest = QueryRequestHelper(payload);
        // navigate(`/repository/mapped-checkpoint/master?${queryRequest}`);
        // navigate(`/activities/self-compliance/my-task?${queryRequest}`);
        switch (dashboardType) {
          case "EXECUTOR":
            return navigate(
              `/activities/self-compliance/my-task?${queryRequest}`
            );
          case "EVALUATOR":
            return navigate(
              `/activities/self-compliance/pending-approval?${queryRequest}`
            );
          case "FUNCTION_HEAD":
            return navigate(
              `/repository/mapped-checkpoint/function-head?${queryRequest}`
            );
          default:
            return navigate(
              `/activities/self-compliance/my-task?${queryRequest}`
            );
        }
      } else {
        toast.error("Please select date");
      }
    }
  };

  const handleNavigateActivity = (
    complianceId: string,
    type: string,
    value: String,
    route: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    var firstDay = params.from_date
      ? params.from_date
      : new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    var lastDay = params.to_date
      ? params.to_date
      : new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);

    let payload = {
      ...params,
      request_from: "DASHBOARD",
      request_type: type,
      request_value: value,
      firstDay: moment(firstDay).format("YYYY-MM-DD"),
      lastDay: moment(lastDay).format("YYYY-MM-DD"),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`/activities/self-compliance/${route}?${queryRequest}`);
  };

  const options1: any = {
    responsive: true,
    barPercentage: 0.3,
    plugins: {
      tooltip: {
        callbacks: {
          title: (xDatapoint: any) => {
            return `${getValue(xDatapoint, `[${0}].dataset.label`, "")}`;
          },
          label: (yDatapoint: any) => {
            return `${yDatapoint.raw}%`;
          },
        },
      },
      datalabels: {
        labels: {
          value: {
            color: "black",
            font: {
              size: 13,
            },
          },
        },
        formatter: (val: any) => {
          return "";
        },
      },
      legend: {
        position: "right" as const,
        color: "white",
        labels: {
          boxWidth: 18, // Set this to your desired width
          boxHeight: 18, // Set this to your desired height
          font: {
            size: 10, // Set this to your desired font size
          },
          // Add any other legend label options here
        },
      },
      title: {
        display: true,
        text: "Overall Self Compliance (%)",
      },
    },
    // scales: {
    //   yAxes: [{ stacked: true }],
    //   xAxes: [
    //     {
    //       stacked: true,
    //     },
    //   ],
    // },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
  };
  /* -------------------------------------------------------------------------- */
  /*                             Download Reports                               */
  /* -------------------------------------------------------------------------- */
  const [downloadLoading, setDownloadLoading] = useState(false);
  const handleDownloadSelfComplianceReport = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    let payload: any = {
      report_type: "SELF_COMPLIANCE_TASK_ENTITY",
      report_name: `self_compliance_task_entity_report_${currentDate()}`,
      from_date: from_date,
      to_date: to_date,
      level: getValue(params, `level`, 0),
      is_list: "true",
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    setDownloadLoading(true);
    try {
      let resp = await exportSelfCompliance({
        ...payload,
      });
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/SELF_COMPLIANCE_TASK_ENTITY`);
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                               Chart Section                                */
  /* -------------------------------------------------------------------------- */
  const chartRef = useRef<any>(null);
  const chartRef1 = useRef<any>(null);
  const barChartRef = useRef<any>(null);

  const handleDownloadClick = () => {
    const chartCanvas = chartRef1.current.canvas;
    if (chartCanvas) {
      const image = chartCanvas
        .toDataURL("image/jpg")
        .replace("image/jpg", "image/octet-stream");

      const a = document.createElement("a");
      a.href = image;
      a.download = "overall.jpg";
      a.click();
    }
  };
  const handleDownloadBarClick = () => {
    const chartCanvas = barChartRef.current.canvas;

    if (chartCanvas) {
      const image = chartCanvas
        .toDataURL("image/jpg")
        .replace("image/jpg", "image/octet-stream");

      const a = document.createElement("a");
      a.href = image;
      a.download = `${getValue(selectedEntity, `[${0}].group_name`, "")}.jpg`;
      a.click();
    }
  };

  const handleRefresh = async () => {
    try {
      let resp = await refreshComplaince();
      if (resp) {
        getData();
      }
    } catch (error) {}
  };

  const handleDownloadPie = (containerId: any) => {
    const chartContainer = document.getElementById(containerId);
    if (chartContainer) {
      html2canvas(chartContainer).then((canvas) => {
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/jpg");
        link.download = "piechart.jpg";
        link.click();
      });
    } else {
      console.error(`Chart container with ID "${containerId}" not found`);
    }
  };
  // Code for Tab Pane

  const [activeTab, setActiveTab] = useState<string>("1");

  const toggleTab = (tab: string) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const dataHelper = (array: any) => {
    if (getValue(array, `length`, 0) > 0) {
      const sum = array.reduce(
        (accumulator: any, currentValue: any) =>
          parseFloat(accumulator) + parseFloat(currentValue),
        0
      );
      return sum;
    } else {
      return 0;
    }
  };

  const formatLabelValue = (value: any) => {
    return value
      .split("_")
      .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const handleNavigateDashboard = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    delete params.is_executor_date;
    delete params.is_evaluator_date;
    delete params.is_function_head_date;
    let payload: any = {
      ...params,
      dashboard_type: value,
    };
    if (value) {
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      delete params.dashboard_type;
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };

  const getImages = (name: string) => {
    switch (name) {
      case "ASSIGNED":
        return <AssignedSvgComponent />;
      case "POSING":
        return <PosingSvgComponent />;
      case "COMPLIED":
        return <CompliedSvgComponent />;
      case "NON_COMPLIED":
        return <NonCompliedSvgComponent />;
      case "DELAYED":
        return <DelayedSvgComponent />;
      case "DELAYED_REPORTED":
        return <DelayReportedSvgComponent />;
      case "RE_OPENED":
        return <ReopenedSvgComponent />;
      case "TOTAL":
        return <TotalSvgComponent />;
      case "DUE_TODAY":
        return <DueTodaySvgComponent />;
      case "UPCOMING":
        return <UpcomingSvgComponent />;
      case "OVERDUE":
        return <OverdueSvgComponent />;
      case "MY_SUBMISSION_FOR_APPROVAL":
        return <SubmissionApprovalSvgComponent />;
      case "PENDING_FOR_MY_APPROVAL":
        return <PendingApprovalSvgComponent />;
      default:
        return;
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                      Activity Module Section                               */
  /* -------------------------------------------------------------------------- */

  const getJSONLogic = (input: any) => {
    const result = Object.keys(input).map((key) => {
      return {
        activity: key,
        count: input[key].count,
      };
    });

    return result;
  };
  const [complianceReports, setComplianceReports] = useState([]);
  const [activityBarChartData, setActivityBarChartData] = useState({
    labels: ["Default"],
    datasets: [
      {
        label: "Compliance",
        data: [98, 120, 138, 138],
        backgroundColor: [
          "#EA7166",
          "#FB9840",
          "#D3AB2A",
          "#F4F6F6",
          // "#05a357",
          // "rgb(195,233,151)",
          // "#F1948A",
        ],
      },
    ],
  });

  const barOptions = {
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  const [executorActivities, setExecutorActivities] = useState([]);
  const [evaluatorActivities, setEvaluatorActivities] = useState([]);
  const [selfActivityLoading, setSelfActivityLoading] = useState(true);
  const getComplianceGraphData = async () => {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = params.from_date
        ? params.from_date
        : new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = params.to_date
        ? params.to_date
        : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      let payload: any = {
        // from_date: convertDate(from_date),
        // to_date: convertDate(to_date),
        ...(params.is_executor_date
          ? {
              owner_due_date_from: convertDate(from_date),
              owner_due_date_to: convertDate(to_date),
            }
          : params.is_evaluator_date
          ? {
              approver_due_date_from: convertDate(from_date),
              approver_due_date_to: convertDate(to_date),
            }
          : params.is_function_head_date
          ? {
              function_head_due_date_from: convertDate(from_date),
              function_head_due_date_to: convertDate(to_date),
            }
          : {
              from_date: convertDate(from_date),
              to_date: convertDate(to_date),
            }),

        dashboard_type: params.dashboard_type
          ? params.dashboard_type
          : dashboardType,
      };
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let levelObj: any = {};
      //finding only levels params if it presented in URL
      for (let i = 1; i < 11; i++) {
        if (getValue(paramsObj, `level${i}`, "")) {
          levelObj[`level_${i}`] = getValue(paramsObj, `level${i}`, "").split(
            "_"
          )[0];
        }
      }
      setSelfActivityLoading(true);
      setGroupChartLoading(true);
      let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
      let resp = await getDashboardSelfActivityByLevel(queryRequest);

      if (resp) {
        let getKeys = Object.keys(getValue(resp, `data`, {}));

        //box response
        if (getKeys.includes("compliance_reports")) {
          let data: any = getJSONLogic(
            getValue(resp, `data.compliance_reports`, {})
          );
          setComplianceReports(data);
        } else {
          setComplianceReports([]);
        }
        if (getKeys.includes("non_complied_task_risk")) {
          let labels = Object.keys(
            getValue(resp, `data.non_complied_task_risk`, {})
          );

          // Transform labels array to capitalize first letter and convert rest to lowercase
          labels = labels.map(
            (label) =>
              label.charAt(0).toUpperCase() + label.slice(1).toLowerCase()
          );

          const data = labels.map((label) =>
            getValue(
              resp,
              `data.non_complied_task_risk[${label.toUpperCase()}].count`,
              {}
            )
          );
          setActivityBarChartData({
            labels,
            datasets: [
              {
                label: "Compliance",
                data,
                // backgroundColor: ["#F4F6F6", "#fd9933", "#05a357", "#d7252e"],
                backgroundColor: ["#EA7166", "#FB9840", "#D3AB2A", "#D0D3D4"],
              },
            ],
          });
        } else {
          setActivityBarChartData({
            labels: ["Default"],
            datasets: [
              {
                label: "Compliance",
                data: [],
                backgroundColor: [
                  "#F4F6F6",
                  "#fd9933",
                  "#05a357",
                  "#d7252e",
                  "#05a357",
                  "rgb(195,233,151)",
                  "#F1948A",
                ],
              },
            ],
          });
        }

        if (getValue(resp, `data.evaluator_activities.length`, 0) > 0) {
          setEvaluatorActivities(
            getValue(resp, `data.evaluator_activities`, []).filter(
              (item: object) => item
            )
          );
        } else {
          setEvaluatorActivities([]);
        }
        if (getValue(resp, `data.executor_activities.length`, 0) > 0) {
          // Assuming getValue and setExecutorActivities are defined functions
          if (getValue(resp, `data.executor_activities.length`, 0) > 0) {
            const activities = getValue(
              resp,
              `data.executor_activities`,
              []
            ).filter((item: object) => item); // Filter out falsy items

            // Sort the details within each executor object
            activities.forEach((executorObj: any) => {
              executorObj.details.sort((a: any, b: any) =>
                a.custom_group.localeCompare(b.custom_group)
              );
            });
            setExecutorActivities(activities); // Set the filtered and sorted activities
          }
        } else {
          setExecutorActivities([]);
        }
        setGroupChartLoading(false);
        setSelfActivityLoading(false);
      } else {
        setSelfActivityLoading(false);
        setGroupChartLoading(false);
      }
    } catch (error) {
      setGroupChartLoading(false);
      setSelfActivityLoading(false);
    }
  };

  const getClassNameForCustomGroup = (customGroup: any) => {
    switch (customGroup) {
      case "COMPLETED":
        return "bg-completed";
      case "OVERDUE":
        return "bg-overdue";
      case "PENDING":
        return "bg-pending";
      default:
        return "bg-primary"; // default class if none of the above match
    }
  };

  const getIcon: any = (name: string) => {
    switch (name) {
      case "OVERDUE":
        return <DOverdueSvgComponent />;
      case "PENDING_FOR_APPROVAL":
        return <DPendingApprovalSvgComponent />;
      case "PENDING_FOR_COMPLETION":
        return <DPendingCompletionSvgComponent />;
      default:
        return null;
    }
  };

  const getTooltipText: any = (name: string) => {
    switch (name) {
      case "OVERDUE":
        return "These tasks are past their legal due date and require your immediate attention.";
      case "PENDING_FOR_APPROVAL":
        return "These tasks are pending your manager/evaluator approval; no action is required at this time.";
      case "PENDING_FOR_COMPLETION":
        return "These tasks have upcoming due dates and need action to avoid non-compliance.";
      case "PENDING_FOR_MY_APPROVAL":
        return "These tasks have been completed by the executor but are awaiting your approval.";
      default:
        return null;
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */
  const [list, setList] = React.useState<[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(15);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: number) => {
    setPage_no(page_no);
    setPage_no_table(page_no);
    getSpecificGroupChart(params.level, page_no);
  };
  const handleChangeLimit = (limit: string) => {
    // const urlSearchParams = new URLSearchParams(window.location.search);
    // const params = Object.fromEntries(urlSearchParams.entries());
    // let payload: any = {
    //   ...params,
    //   limit: limit,
    //   page_no: "1",
    // };
    // let queryRequest = QueryRequestHelper(payload);
    // navigate(`${window.location.pathname}?${queryRequest}`);
    setPage_no(page_no);
    setPage_no_table(page_no);
    getSpecificGroupChart(params.level, page_no);
  };
  const rowClick = (obj: object) => {
    if (
      getValue(obj, `original.id`, "") &&
      getValue(obj, `original.self_compliance.checkpoint.id`, "")
    ) {
      // let queryRequest = QueryRequestHelper(payload);
      // navigate(`/dashboard/self-compliance/my-activity-v2?${queryRequest}`);
      navigate(`/dashboard/self-compliance/my-activity-v2`);
    } else {
      toast.error("Checkpoint not available");
    }
  };

  // Pagination Table
  const [listTable, setListTable] = React.useState<[]>([]);
  const [totalCountTable, setTotalCountTable] = useState(0);
  const [limitTable, setLimitTable] = useState(15);
  const [page_no_table, setPage_no_table] = useState(1);

  const handleChangePaginationTable = (page_no_table: number) => {
    setPage_no(page_no_table);
    setPage_no_table(page_no_table);
    getSpecificGroupChart(params.level, page_no_table);
  };
  const handleChangeLimitTable = (limit: string) => {
    setPage_no_table(page_no_table);
    setPage_no(page_no_table);
    getSpecificGroupChart(params.level, page_no_table);
  };
  // console.log(getValue(props, `tabPermissionList`, []));
  // console.log(getValue(props, `subTabPermissionList`, []));

  // Legal List

  const getPayloadLegalList = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let industrySelectedIDs: any = urlSearchParams.getAll("industries[]");
    let regulationSelectedIDs: any = urlSearchParams.getAll("regulations[]");
    let ministrySelectedIDs: any = urlSearchParams.getAll("ministries[]");
    let departmentSelectedIDs: any = urlSearchParams.getAll("departments[]");
    let statesSelectedIDs: any = urlSearchParams.getAll("states[]");
    let tagsSelectedIDs: any = urlSearchParams.getAll("tags[]");
    let notificationTypeSelectedIDs: any = urlSearchParams.getAll(
      "notification_type[]"
    );

    // let notificationTypeSelectedIDs: any = urlSearchParams.getAll("notification_type");

    // let compliance_task_ids: any = urlSearchParams.getAll(
    //   "compliance_task_ids[]"
    // );

    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    let payload: any = {
      from_date: getValue(params, `from_date`, "")
        ? getValue(params, `from_date`, "")
        : convertDate(from_date),

      to_date: getValue(params, `to_date`, "")
        ? getValue(params, `to_date`, "")
        : convertDate(to_date),

      //   from_date: getValue(params, `is_all_time`, "")
      //   ? ""
      //   : getValue(params, `from_date`, "")
      //   ? getValue(params, `from_date`, "")
      //   : convertDate(from_date),
      // to_date: getValue(params, `is_all_time`, "")
      //   ? ""
      //   : getValue(params, `to_date`, "")
      //   ? getValue(params, `to_date`, "")
      //   : convertDate(to_date),

      // compliance_status: getValue(params, `compliance_status`, ""),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      // page_size: params.limit ? parseInt(params.limit) : limit,
      page_size: 3,
      sort_by: params.sort_by,
      search_text: params.search_text,
      country_id: parseInt(getValue(params, `country_id`, "")),
      state_id: parseInt(getValue(params, `state_id`, "")),
      // compliance_type_id: getValue(params, `compliance_type_id`, ""),
      // self_compliance_task_ids: compliance_task_ids,
      industries:
        industrySelectedIDs.length > 0
          ? industrySelectedIDs.map((item: string) => ({ id: item }))
          : [],
      regulations:
        regulationSelectedIDs.length > 0
          ? regulationSelectedIDs.map((item: string) => ({ id: item }))
          : [],
      ministries:
        ministrySelectedIDs.length > 0
          ? ministrySelectedIDs.map((item: string) => ({ id: item }))
          : [],
      departments:
        departmentSelectedIDs.length > 0
          ? departmentSelectedIDs.map((item: string) => ({ id: item }))
          : [],
      states:
        statesSelectedIDs.length > 0
          ? statesSelectedIDs.map((item: string) => ({ id: item }))
          : [],
      tags:
        tagsSelectedIDs.length > 0
          ? tagsSelectedIDs.map((item: string) => ({ id: item }))
          : [],
      notification_type:
        notificationTypeSelectedIDs.length > 0
          ? notificationTypeSelectedIDs.map((item: string) => ({ id: item }))
          : [],
      // notification_type : notificationTypeSelectedIDs[0]

      // status: getValue(params, `status`, "")
      //   ? getValue(params, `status`, "")
      //   : "active",
      // request_from:
      //   getValue(compliance_task_ids, `length`, 0) > 0
      //     ? ""
      //     : getValue(params, `request_from`, "")
      //     ? getValue(params, `request_from`, "")
      //     : "MASTER",
    };
    return { ...payload };
  };

  const [legalList, setLegalList] = useState([]);

  const getDataLegalList = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      // page_size: params.limit ? parseInt(params.limit) : 3,
      page_size: 3,
      // limit: 3,
      search_text: params.search_text,
      sort_by: params.sort_by,
      is_active: true,
    };
    // let queryRequest = QueryRequestHelper(payload);
    let payloadObj = await getPayloadLegalList();
    let queryRequest = QueryRequestHelper({
      ...payload,
      ...payloadObj,
    });

    try {
      setIsLoading(true);
      let resp = await legalUpdate({ ...payload, ...payloadObj });
      if (resp) {
        setLegalList(getValue(resp, `data.blogData`, []));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  //blogs Popup
  const [showBlogsPopup, setShowBlogsPopup] = useState(false);
  const [blogInfo, setBlogInfo] = useState({});
  const handleViewBlogs = async (data: object) => {
    setShowBlogsPopup(true);
    setBlogInfo(data);
  };

  const navigateOldDashboard = () => {
    navigate(`/dashboard/self-compliance/my-activity`);
  };

  const handleCheckExecutorDate = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {};
    if (getValue(params, `is_executor_date`, "")) {
      delete params["is_executor_date"];
      payload = {
        ...params,
        page_no: 1,
      };
    } else {
      payload = {
        ...params,
        is_executor_date: true,
      };
    }

    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!getValue(params, `is_executor_date`, "")) {
      getData();
      getComplianceGraphData();
    }
  };

  const handleCheckEvaluatorDate = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {};
    if (getValue(params, `is_evaluator_date`, "")) {
      delete params["is_evaluator_date"];
      payload = {
        ...params,
        page_no: 1,
      };
    } else {
      payload = {
        ...params,
        is_evaluator_date: true,
      };
    }

    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!getValue(params, `is_evaluator_date`, "")) {
      getData();
      getComplianceGraphData();
    }
  };

  const handleCheckFunctionHeadDate = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {};
    if (getValue(params, `is_function_head_date`, "")) {
      delete params["is_function_head_date"];
      payload = {
        ...params,
        page_no: 1,
      };
    } else {
      payload = {
        ...params,
        is_function_head_date: true,
      };
    }

    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!getValue(params, `is_function_head_date`, "")) {
      getData();
      getComplianceGraphData();
    }
  };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "dashboard_self_compliance_my_activity"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between d-none">
            <h4 className="dashbaord-wrapper__header-title">Self Compliance</h4>
            <div className="d-flex">
              <div className="refresh-button-wrapper">
                <button onClick={() => handleRefresh()} className={`btn`}>
                  <RefreshSvgComponent size={24} color={"#5F6368"} />
                </button>
              </div>
              <div className="filter-form-wrappper__container d-flex ms-2">
                {/* Legal Due Date */}
                <DatePicker
                  selectsRange={true}
                  startDate={from_date}
                  endDate={to_date}
                  className="react-date-picker__inputGroup__input"
                  onChange={(update: any) => {
                    handleDate(update);
                  }}
                  dateFormat="d MMM yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  placeholderText="Legal Due Date"
                />
                <button
                  className="dashboard-wrapper__apply-btn"
                  onClick={handleSubmitDate}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <DashboardSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Self Compliance
                </h6>
                <h4 className="dashbaord-wrapper__header-title">Compliance</h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              {/* <span className="mx-1 header_text__blue cursor-pointer" onClick={navigateOldDashboard}>
                View Old Dashboard
              </span> */}

              {/* <div className=" d-flex align-items-center mx-2">
                <h4 className="header_text__blue">Switch to Executor Date</h4>
                <div className="choicelist-wrapper custom-switch-wrapper ms-2 mt-1">
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={getValue(params, `is_executor_date`, "") ? true : false}
                      onChange={() => handleCheckExecutorDate()}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>

              <div className=" d-flex align-items-center mx-2">
                <h4 className="header_text__blue">Switch to Evaluator Date</h4>
                <div className="choicelist-wrapper custom-switch-wrapper ms-2 mt-1">
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={getValue(params, `is_evaluator_date`, "") ? true : false}
                      onChange={() => handleCheckEvaluatorDate()}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>

              <div className=" d-flex align-items-center mx-2">
                <h4 className="header_text__blue">Switch to Function Head Date</h4>
                <div className="choicelist-wrapper custom-switch-wrapper ms-2 mt-1">
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={getValue(params, `is_function_head_date`, "") ? true : false}
                      onChange={() => handleCheckFunctionHeadDate()}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div> */}

              {/* Working Code */}
              {/* {params.dashboard_type === 'EXECUTOR' && (
                <div className="d-flex align-items-center mx-2">
                  <h4 className="header_text__blue">Switch to Executor Date</h4>
                  <div className="choicelist-wrapper custom-switch-wrapper ms-2 mt-1">
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={getValue(params, `is_executor_date`, "") ? true : false}
                        onChange={() => handleCheckExecutorDate()}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
              )}

              {params.dashboard_type === 'EVALUATOR' && (
                <div className="d-flex align-items-center mx-2">
                  <h4 className="header_text__blue">Switch to Evaluator Date</h4>
                  <div className="choicelist-wrapper custom-switch-wrapper ms-2 mt-1">
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={getValue(params, `is_evaluator_date`, "") ? true : false}
                        onChange={() => handleCheckEvaluatorDate()}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
              )}

              {params.dashboard_type === 'FUNCTION_HEAD' && (
                <div className="d-flex align-items-center mx-2">
                  <h4 className="header_text__blue">Switch to Function Head Date</h4>
                  <div className="choicelist-wrapper custom-switch-wrapper ms-2 mt-1">
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={getValue(params, `is_function_head_date`, "") ? true : false}
                        onChange={() => handleCheckFunctionHeadDate()}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
              )} */}

              <RightMenuHeaders
                smartFilter={false}
                handleFilter={handleFilter}
                lineSeperator={true}
                selectedFilterCount={countKeysWithValues(params)}
                // date range
                dateRange={true}
                from_date={from_date}
                to_date={to_date}
                handleDate={handleDate}
                handleSubmitDate={handleSubmitDate}
                licenseStyleCalendar={true}
              />
              <div className="refresh-button-wrapper sub-header-icons-holder ms-0">
                <button
                  onClick={() => handleRefresh()}
                  className={`icons-btn`}
                  data-tip
                  data-for="checkTest"
                >
                  <RefreshSvgComponent size={24} color={"#5F6368"} />
                  <ReactTooltip id="checkTest" effect="solid" place="bottom">
                    Refresh
                  </ReactTooltip>
                </button>
              </div>
            </div>
          </div>

          <div className="main-page-layout-wrapper main-page-layout-wrapper-dashboard">
            <div className="admin-wrapper position-relative">
              <>
                <DashboardUserFilterForm
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  reset={reset}
                  handleSubmitSmartFilter={handleSubmitSmartFilter}
                  //-----> Entity Mapping Filter
                  headerList={headerList}
                  headerLoading={headerLoading}
                  levelObj={levelObj}
                  childEntityLoading={childEntityLoading}
                  handleClickEntity={handleClickEntity}
                  urlParams={paramsObj}
                  handleChangeEntity={handleChange}
                  filterIsOpen={filterIsOpen}
                  handleFilter={handleFilter}
                  moduleName={"Self Compliance"}
                  subModuleName={"Compliance"}
                />
              </>
            </div>

            {getValue(pageFilters, "length", 0) > 1 ? (
              <div className="module-filter-wrapper">
                <div className="module_filter_fields_wrapper">
                  <label htmlFor="is_configured" className="floating-label">
                    View as
                  </label>
                  <SearchableDropdownSelect
                    placeholder={"Choose View as"}
                    // options={filters}
                    options={pageFilters}
                    handleChange={(e: any) =>
                      handleNavigateDashboard(getValue(e, `value`, ""))
                    }
                    handleClick={(e: any) =>
                      handleNavigateDashboard(getValue(e, `value`, ""))
                    }
                    value={
                      getValue(pageFilters, `length`, 0) > 0
                        ? pageFilters.find(
                            (item: object) =>
                              getValue(item, `value`, "") == dashboardType
                          )
                        : {}
                    }
                    className="form-control"
                    name="compliance_type_id"
                    label="label"
                    id="id"
                    removeClose
                  />
                </div>
              </div>
            ) : null}

            <div className="entity_chart-container pb-0">
              <div className="entity_float">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="entity-header-container">
                    {getValue(headerGroupList, `length`, 0) > 0 ? (
                      headerGroupList.map((item: object, index: number) => {
                        return (
                          <div key={index}>
                            <div
                              className={`entity-header ${
                                getValue(item, `group_level`, "") ==
                                getValue(params, `level`, "")
                                  ? `active`
                                  : index === 0 &&
                                    !getValue(params, `level`, "")
                                  ? "active"
                                  : ""
                              }`}
                              onClick={() =>
                                handleClickGroupPieChart(
                                  getValue(item, `group_level`, ""),
                                  getValue(item, `group_name`, "")
                                )
                              }
                            >
                              <p className="entity-header_text">
                                {getValue(item, `group_name`, "")}
                              </p>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </div>
                  <div></div>
                </div>
                <hr />

                <div>
                  {groupChartLoading ? (
                    <GraphLoader />
                  ) : (
                    <div>
                      {getValue(params, `level`, "") ? (
                        getValue(
                          groupPieChart,
                          `datasets[${0}].data.length`,
                          0
                        ) === 0 ? (
                          <div style={{ height: "375px" }}>
                            <DashboardSelfComplianceNotfound />
                          </div>
                        ) : (
                          <>
                            <div className="vendor-graph-holder">
                              <div className="self-compliance-download-button-holder">
                                <button
                                  onClick={handleDownloadBarClick}
                                  className="download_chart mx-1 hover-effective-icon-btn"
                                >
                                  <DownloadNoCircleSvgComponent
                                    size={20}
                                    color={"#5F6368"}
                                  />
                                </button>
                              </div>

                              <div style={{ height: "320px" }}>
                                <Bar
                                  data={groupPieChart}
                                  options={{
                                    ...options1,
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    // onClick: function (evt, element) {
                                    //   let ind = getValue(element, `[${0}].index`, null);
                                    //   if (element.length > 0) {
                                    //     handleOnClickGroupPieChart(ind);
                                    //   }
                                    // },
                                  }}
                                  ref={barChartRef}
                                />
                              </div>
                              {totalCount > 15 && (
                                <div className="footer-wrap border-top pt-2 mt-2">
                                  <PaginationPage
                                    // list={list}
                                    totalCount={totalCount}
                                    limit={limit}
                                    page_no={page_no}
                                    pageNumber={page_no}
                                    showLimit={"false"}
                                    handleChangePagination={
                                      handleChangePagination
                                    }
                                    handleChangeLimit={handleChangeLimit}
                                  />
                                </div>
                              )}
                            </div>
                          </>
                        )
                      ) : getValue(
                          pieChartData,
                          `datasets[${0}].data.length`,
                          0
                        ) === 0 ? null : (
                        <>
                          <div className="navtabs-pillable">
                            {getValue(
                              pieChartData,
                              `datasets[${0}].data.length`,
                              0
                            ) > 0 &&
                            dataHelper(
                              getValue(pieChartData, `datasets[${0}].data`, [])
                            ) > 0 &&
                            getValue(
                              pieChartData1,
                              `datasets[${0}].data.length`,
                              0
                            ) > 0 &&
                            dataHelper(
                              getValue(pieChartData1, `datasets[${0}].data`, [])
                            ) > 0 ? (
                              <Nav
                                tabs
                                className="justify-content-end align-items-center"
                              >
                                <NavItem>
                                  <NavLink
                                    className={
                                      activeTab === "1" ? "active" : ""
                                    }
                                    onClick={() => toggleTab("1")}
                                  >
                                    {" "}
                                    Percentage Graph
                                  </NavLink>
                                </NavItem>

                                <NavItem>
                                  <NavLink
                                    className={
                                      activeTab === "2" ? "active" : ""
                                    }
                                    onClick={() => toggleTab("2")}
                                  >
                                    {" "}
                                    Number Graph
                                  </NavLink>
                                </NavItem>
                              </Nav>
                            ) : null}

                            <TabContent activeTab={activeTab}>
                              <TabPane tabId="1">
                                {getValue(
                                  pieChartData,
                                  `datasets[${0}].data.length`,
                                  0
                                ) > 0 &&
                                dataHelper(
                                  getValue(
                                    pieChartData,
                                    `datasets[${0}].data`,
                                    []
                                  )
                                ) > 0 ? (
                                  <div
                                    // style={{ height: "350px" }}
                                    className="vendor-graph-holder"
                                  >
                                    <div className="self-compliance-download-button-holder">
                                      <h6 className="d-none">
                                        Percentage Graph
                                      </h6>
                                      <button
                                        onClick={() =>
                                          handleDownloadPie("percentageGraph")
                                        }
                                        className="download_chart mx-1 hover-effective-icon-btn"
                                      >
                                        <DownloadNoCircleSvgComponent
                                          size={20}
                                          color={"#5F6368"}
                                        />
                                      </button>
                                    </div>

                                    <div style={{ height: "350px" }}>
                                      <div
                                        id="percentageGraph"
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                      >
                                        <ResponsivePie
                                          data={donutData}
                                          margin={{
                                            top: 40,
                                            right: 80,
                                            bottom: 40,
                                            left: -40,
                                          }}
                                          colors={colorsChartNew}
                                          innerRadius={0.5}
                                          padAngle={0}
                                          cornerRadius={0}
                                          activeOuterRadiusOffset={10}
                                          borderWidth={1}
                                          borderColor={{
                                            from: "color",
                                            modifiers: [["darker", 0.2]],
                                          }}
                                          arcLinkLabelsDiagonalLength={16}
                                          arcLinkLabelsTextColor="#333333"
                                          arcLinkLabelsThickness={2}
                                          arcLinkLabelsColor={{ from: "color" }}
                                          arcLabelsSkipAngle={2}
                                          arcLabelsTextColor={{
                                            from: "color",
                                            modifiers: [["darker", 2]],
                                          }}
                                          arcLabel={(d) =>
                                            `${d.formattedValue}%`
                                          }
                                          arcLinkLabel={(e) => {
                                            const displayValue =
                                              formatLabelValue(e.id.toString());
                                            return (
                                              `${displayValue}` +
                                              (" (" + e.value + "%)")
                                            );
                                          }}
                                          arcLinkLabelsOffset={1}
                                          arcLinkLabelsStraightLength={30}
                                          arcLinkLabelsTextOffset={6}
                                          arcLinkLabelsSkipAngle={3}
                                          onClick={(data: any) => {
                                            const index = data.arc.index;
                                            handleClickPieChart(
                                              index,
                                              convertCamelToSnakeCase(
                                                getValue(data, `id`, "")
                                              )
                                            );
                                          }}
                                          legends={[
                                            {
                                              anchor: "top-right",
                                              direction: "column",
                                              justify: false,
                                              itemsSpacing: 5,
                                              itemWidth: 100,
                                              itemHeight: 18,
                                              itemTextColor: "#999",
                                              itemDirection: "left-to-right",
                                              itemOpacity: 1,
                                              symbolSize: 18,
                                              symbolShape: "square",
                                              effects: [
                                                {
                                                  on: "hover",
                                                  style: {
                                                    itemTextColor: "#000",
                                                  },
                                                },
                                              ],
                                              onClick: (
                                                legendDonutData: any
                                              ) => {
                                                const idx = donutData.findIndex(
                                                  (s) =>
                                                    s.id === legendDonutData.id
                                                );
                                                if (idx !== -1) {
                                                  handleClickPieChart(
                                                    idx,
                                                    convertCamelToSnakeCase(
                                                      getValue(
                                                        legendDonutData,
                                                        `id`,
                                                        ""
                                                      )
                                                    )
                                                  );
                                                }
                                              },
                                              data: legendDonutData.map(
                                                (item: any, index: any) => ({
                                                  id: item.id,
                                                  label: `${item.id} (${item.value}%)`,
                                                  color:
                                                    colorsChartNew[
                                                      index %
                                                        colorsChartNew.length
                                                    ],
                                                })
                                              ),
                                            },
                                          ]}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <>
                                    <DashboardSelfComplianceNotfound />
                                  </>
                                )}
                              </TabPane>

                              <TabPane tabId="2">
                                {getValue(
                                  pieChartData1,
                                  `datasets[${0}].data.length`,
                                  0
                                ) > 0 &&
                                dataHelper(
                                  getValue(
                                    pieChartData1,
                                    `datasets[${0}].data`,
                                    []
                                  )
                                ) > 0 ? (
                                  <div
                                    style={{ height: "350px" }}
                                    className="vendor-graph-holder"
                                  >
                                    <div className="d-flex justify-content-between align-items-center self-compliance-download-button-holder">
                                      <h6 className="d-none">Number Graph</h6>
                                      <button
                                        onClick={() =>
                                          handleDownloadPie("numberGraph")
                                        }
                                        className="download_chart mx-1 hover-effective-icon-btn"
                                      >
                                        <DownloadNoCircleSvgComponent
                                          size={20}
                                          color={"#5F6368"}
                                        />
                                      </button>
                                    </div>

                                    <div
                                      id="numberGraph"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                      }}
                                    >
                                      <ResponsivePie
                                        data={numberDonutData}
                                        margin={{
                                          top: 40,
                                          right: 80,
                                          bottom: 40,
                                          left: -40,
                                        }}
                                        colors={colorsChartNew}
                                        innerRadius={0.5}
                                        padAngle={0}
                                        cornerRadius={0}
                                        activeOuterRadiusOffset={10}
                                        borderWidth={1}
                                        borderColor={{
                                          from: "color",
                                          modifiers: [["darker", 0.2]],
                                        }}
                                        arcLinkLabelsDiagonalLength={16}
                                        arcLinkLabelsTextColor="#333333"
                                        arcLinkLabelsThickness={2}
                                        arcLinkLabelsColor={{ from: "color" }}
                                        arcLabelsSkipAngle={2}
                                        arcLabelsTextColor={{
                                          from: "color",
                                          modifiers: [["darker", 2]],
                                        }}
                                        arcLabel={(d) => `${d.formattedValue}`}
                                        arcLinkLabel={(e) => {
                                          const displayValue = formatLabelValue(
                                            e.id.toString()
                                          );
                                          return (
                                            `${displayValue}` +
                                            (" (" + e.value + ")")
                                          );
                                        }}
                                        arcLinkLabelsOffset={1}
                                        arcLinkLabelsStraightLength={30}
                                        arcLinkLabelsTextOffset={6}
                                        arcLinkLabelsSkipAngle={3}
                                        onClick={(data: any) => {
                                          const index = data.arc.index;
                                          handleClickPieChart(
                                            index,
                                            convertCamelToSnakeCase(
                                              getValue(data, `id`, "")
                                            )
                                          );
                                        }}
                                        legends={[
                                          {
                                            anchor: "top-right",
                                            direction: "column",
                                            justify: false,
                                            itemsSpacing: 5,
                                            itemWidth: 100,
                                            itemHeight: 18,
                                            itemTextColor: "#999",
                                            itemDirection: "left-to-right",
                                            itemOpacity: 1,
                                            symbolSize: 18,
                                            symbolShape: "square",
                                            effects: [
                                              {
                                                on: "hover",
                                                style: {
                                                  itemTextColor: "#000",
                                                },
                                              },
                                            ],
                                            onClick: (legendDonutData: any) => {
                                              const idx =
                                                numberDonutData.findIndex(
                                                  (s) =>
                                                    s.id === legendDonutData.id
                                                );
                                              if (idx !== -1) {
                                                handleClickPieChart(
                                                  idx,
                                                  convertCamelToSnakeCase(
                                                    getValue(
                                                      legendDonutData,
                                                      `id`,
                                                      ""
                                                    )
                                                  )
                                                );
                                              }
                                            },
                                            data: legendNumberDonutData.map(
                                              (item: any, index: any) => ({
                                                id: item.id,
                                                label: `${item.id} (${item.value})`,
                                                color:
                                                  colorsChartNew[
                                                    index %
                                                      colorsChartNew.length
                                                  ],
                                              })
                                            ),
                                          },
                                        ]}
                                      />
                                    </div>
                                  </div>
                                ) : (
                                  <>
                                    <DashboardSelfComplianceNotfound />
                                  </>
                                )}
                              </TabPane>
                            </TabContent>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {getValue(params, `level`, "") ? (
              <>
                {groupChartLoading ? (
                  <Loader />
                ) : getValue(groupChart, `length`, 0) > 0 &&
                  getValue(params, `level`, "") ? (
                  <>
                    <h3
                      // style={{ marginLeft: "2%" }}
                      className="self-compliance-table-title mt-3"
                    >
                      {getValue(selectedEntity, `[${0}].group_name`, "")}
                    </h3>
                    {/* <SelfComplianceTable
                      headerList={headerList}
                      data={groupChart}
                      handleNavigate={handleClickGroupCharts}
                    /> */}
                    {getValue(params, `group_name`, "") === "Function" ? (
                      <ExpandableComplianceTableMyActivity
                        parentData={groupChart}
                        handleNavigate={handleNavigate}
                        fromDate={from_date}
                        toDate={to_date}
                        level={getValue(params, `level`, "")}
                      />
                    ) : (
                      <SelfComplianceTable
                        headerList={headerList}
                        data={groupChart}
                        handleNavigate={handleNavigate}
                      />
                    )}
                  </>
                ) : // <Notfound />
                null}
              </>
            ) : null}
            {/* <br /> */}
            {!getValue(params, `level`, "") && (
              <>
                <div className="d-flex w-100 pb-3 gap pr-16 compliance-graph-table-wrap">
                  <div className="w-50 dashboard-card-struc ">
                    {groupChartLoading ? (
                      <GraphLoader />
                    ) : (
                      <Bar
                        data={activityBarChartData}
                        options={{
                          ...barOptions,

                          onClick: function (evt, element) {
                            let ind = getValue(element, `[${0}].index`, null);
                            if (element.length > 0) {
                              handleClickNewBarChart(ind);
                            }
                          },
                        }}
                      />
                    )}
                  </div>
                  {getValue(complianceReports, `length`, 0) > 0 && (
                    <div className="dashboard-card-struc w-50">
                      <h6 className="dcs-title">Compliance Statistics</h6>
                      <div className="compliance-stats-cards-wrap d-flex">
                        {/* <div className=" d-flex align-items-center"> */}
                        {complianceReports.map((obj: any, index: number) => {
                          return (
                            <div className="compliance-stats-cards">
                              <div className="">
                                <section
                                  className={`cursor-pointer d-flex align-items-center  
                                     `}
                                  //  breakup-box--${obj.color} breakup-box--${obj.background}
                                  //   style={{ backgroundColor: random_rgba() }}
                                  onClick={() =>
                                    getValue(obj, `count`, 0) > 0 &&
                                    handleClickNewBoxChart(obj)
                                  }
                                >
                                  {/* <div className="">
                                      {getImages(getValue(obj, `activity`, ""))}
                                    </div> */}
                                  <div className="breakup-box__details">
                                    <h6
                                      className={`breakup-box__title breakup-box__title--${obj.color}`}
                                    >
                                      {getValue(obj, `count`, "")}
                                    </h6>
                                    <p
                                      className={`breakup-box__text d-flex breakup-box__text--${obj.color}`}
                                    >
                                      {formatText(
                                        getValue(obj, `activity`, "")
                                      )}
                                      <span
                                        className="info-icon-holder"
                                        data-tip
                                        data-for={`stats-tip-${obj.activity}`}
                                      >
                                        <InfoSvgComponent />
                                      </span>
                                    </p>

                                    <div className="icon-wrapper">
                                      {getIcon(getValue(obj, "activity", ""))}
                                    </div>
                                  </div>
                                  {/* <img
                                      src={obj.image}
                                      className="img-fluid breakup-box-image"
                                    /> */}
                                  <ReactTooltip
                                    id={`stats-tip-${obj.activity}`}
                                    effect="solid"
                                    place="bottom"
                                  >
                                    {getTooltipText(
                                      getValue(obj, "activity", "")
                                    )}
                                  </ReactTooltip>
                                </section>
                              </div>
                            </div>
                          );
                        })}
                        {/* </div> */}
                      </div>
                    </div>
                  )}
                  {/* </div>

                <div className="w-100 pb-3 d-flex gap"> */}
                  {getValue(executorActivities, `length`, 0) > 0 && (
                    <>
                      {/* Executor Table */}
                      <div className="myactivity-dummy-table-wrap w-50">
                        <>
                          {getValue(executorActivities, `length`, 0) > 0 &&
                            executorActivities.map((main, index) => {
                              return (
                                <div className="dummy-table-tr">
                                  <div className="d-flex w-100">
                                    <div>
                                      {index === 0 && (
                                        <p className="th-title mw-180">
                                          Executor
                                        </p>
                                      )}
                                      <p className="mw-180 dummy-td">
                                        {getValue(
                                          main,
                                          `executor.first_name`,
                                          ""
                                        )}{" "}
                                        {getValue(
                                          main,
                                          `executor.last_name`,
                                          ""
                                        )}
                                      </p>
                                    </div>
                                    <div
                                      className="d-flex"
                                      style={{ width: "60%" }}
                                    >
                                      {getValue(main, `details`, []).map(
                                        (item: object, i: number) => {
                                          const customGroup = getValue(
                                            item,
                                            "custom_group",
                                            ""
                                          );
                                          const badgeClassName =
                                            getClassNameForCustomGroup(
                                              customGroup
                                            );

                                          return (
                                            <div
                                              className=" mw-90"
                                              onClick={() =>
                                                getValue(
                                                  item,
                                                  `details.count`,
                                                  0
                                                ) > 0 &&
                                                handleClickActivities(
                                                  item,
                                                  "EXECUTOR_ACTIVITIES",
                                                  getValue(
                                                    main,
                                                    `executor.id`,
                                                    ""
                                                  )
                                                )
                                              }
                                            >
                                              <div className="cursor-pointer">
                                                {index === 0 && (
                                                  <p className="th-title">
                                                    {formatText(
                                                      getValue(
                                                        item,
                                                        `custom_group`,
                                                        ""
                                                      )
                                                    )}
                                                  </p>
                                                )}
                                                <p className="dummy-td">
                                                  <span className="d-flex">
                                                    {getValue(
                                                      item,
                                                      `details.count`,
                                                      ""
                                                    )}
                                                    <span
                                                      className={`badge ${badgeClassName} ms-1`}
                                                    >
                                                      {getValue(
                                                        item,
                                                        `details.percentage`,
                                                        ""
                                                      )}
                                                      %
                                                    </span>
                                                  </span>
                                                </p>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                        </>
                      </div>
                    </>
                  )}
                  {getValue(evaluatorActivities, `length`, 0) > 0 && (
                    <>
                      {/* Executor Table */}
                      <div className="myactivity-dummy-table-wrap w-50">
                        <>
                          {getValue(evaluatorActivities, `length`, 0) > 0 &&
                            evaluatorActivities.map((main, index) => {
                              return (
                                <div className="dummy-table-tr">
                                  <div className="d-flex w-100">
                                    <div style={{ width: "40%" }}>
                                      {index === 0 && (
                                        <p className="th-title mw-180">
                                          Evaluator
                                        </p>
                                      )}
                                      <p className="mw-180 dummy-td ">
                                        {getValue(
                                          main,
                                          `evaluator.first_name`,
                                          ""
                                        )}{" "}
                                        {getValue(
                                          main,
                                          `evaluator.last_name`,
                                          ""
                                        )}
                                      </p>
                                    </div>
                                    <div
                                      className="d-flex"
                                      style={{ width: "60%" }}
                                    >
                                      {getValue(main, `details`, []).map(
                                        (item: object, i: number) => {
                                          const customGroup = getValue(
                                            item,
                                            "custom_group",
                                            ""
                                          );
                                          const badgeClassName =
                                            getClassNameForCustomGroup(
                                              customGroup
                                            );
                                          return (
                                            <div
                                              className=" mw-90 w-100"
                                              onClick={() =>
                                                getValue(
                                                  item,
                                                  `details.count`,
                                                  0
                                                ) > 0 &&
                                                handleClickActivities(
                                                  item,
                                                  "EVALUATOR_ACTIVITIES",
                                                  getValue(
                                                    main,
                                                    `evaluator.id`,
                                                    ""
                                                  )
                                                )
                                              }
                                            >
                                              <div className="cursor-pointer">
                                                {index === 0 && (
                                                  <p className="th-title text-right">
                                                    {/* {formatText(
                                                      getValue(
                                                        item,
                                                        `custom_group`,
                                                        ""
                                                      )
                                                    )} */}
                                                    Pending For Approval
                                                  </p>
                                                )}
                                                <p className="dummy-td text-right justify-content-end">
                                                  <span className="d-flex">
                                                    {getValue(
                                                      item,
                                                      `details.count`,
                                                      ""
                                                    )}
                                                    {/* <span
                                                      className={`badge ${badgeClassName} ms-1`}
                                                    >
                                                      {getValue(
                                                        item,
                                                        `details.percentage`,
                                                        ""
                                                      )}
                                                      %
                                                    </span> */}
                                                  </span>
                                                </p>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                        </>
                      </div>
                    </>
                  )}

                  {localStorage.getItem("op") === "false" ? (
                    <>
                      {getValue(legalList, `length`, 0) > 0 && (
                        <div className="dashboard-card-struc w-50">
                          <h6 className="dcs-title">Legal Update</h6>
                          <div className="myactivity-legal-update-wrap">
                            {/* {legalList.map((legalObj: any, index: any) => { */}
                            {legalList
                              .slice(0, 3)
                              .map((legalObj: any, index: any) => {
                                let html: any = concatString(
                                  decodeBase64(
                                    getValue(legalObj, "content", "")
                                  ),
                                  250
                                );
                                return (
                                  <>
                                    <div
                                      className="border-bottom pb-2 mb-2 cursor-pointer"
                                      onClick={() => {
                                        handleViewBlogs(legalObj);
                                      }}
                                    >
                                      <div className="legal-title mb-1">
                                        {concatString(
                                          getValue(legalObj, `title`, ""),
                                          80
                                        )}
                                      </div>
                                      <div className="legal-tags-wrap mb-1">
                                        {getValue(legalObj, `tags`, []).map(
                                          (tagObj: any, index: any) => {
                                            return (
                                              <>
                                                <div className="badge me-1">
                                                  {getValue(tagObj, `text`, "")}
                                                </div>
                                              </>
                                            );
                                          }
                                        )}
                                      </div>

                                      {/* <div className="legal-desc small mb-1">
                                  {concatString(
                                    getValue(legalObj, `content`, ""),
                                    150
                                  )}
                                </div> */}

                                      <div
                                        className="legal-desc small mb-1"
                                        dangerouslySetInnerHTML={{
                                          __html: html,
                                        }}
                                      ></div>

                                      <div className="legal-time-stamp mb-1">
                                        {convertDateAsString(
                                          getValue(legalObj, `updated_at`, "")
                                        )}
                                      </div>

                                      <div className="read-more-link cursor-pointer">
                                        <a
                                          onClick={() => {
                                            handleViewBlogs(legalObj);
                                          }}
                                        >
                                          Read More
                                        </a>
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </>
            )}
          </div>

          <DashboardBlogsViewPopup
            showBlogsPopup={showBlogsPopup}
            setShowBlogsPopup={setShowBlogsPopup}
            // editorState={editorState}
            // onEditorStateChange={onEditorStateChange}
            blogInfo={blogInfo}
          />
          {getValue(params, `level`, "") ? (
            <div className="footer-wrap">
              <FooterWrapper
                list={headerList}
                totalCount={totalCountTable}
                limit={limitTable}
                page_no={page_no_table}
                handleChangePagination={handleChangePaginationTable}
                handleChangeLimit={handleChangeLimitTable}
                hideRowsPerPage={true}
              />
            </div>
          ) : null}
        </>
      )}
    </DashboardLayout>
  );
}
